import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import Text from "components/Text";
import crossIcon from "assets/images/cross.svg";
import styles from "../OfficePolicyManagement.module.scss";

export default function CancelAssignmentModal({
  isOpen,
  toggle,
  onConfirm,
  assignmentId,
}) {
  const { t } = useTranslation();

  const handleApply = () => {
    if (assignmentId) onConfirm?.(assignmentId);
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <button type="button" className="close-btn" onClick={toggle} aria-label="Close">
        <img src={crossIcon} alt="close" />
      </button>
      <ModalBody>
        <div className={styles.delete_task_modal}>
          <Text size="25px" weight="500" color="#111B45">
            {t("officePolicyManagement.cancelPolicy")}
          </Text>
          <Text size="16px" weight="300" color="#535B5F">
            {t("officePolicyManagement.cancelConfirmation")}
          </Text>
          <div
            className={`${styles.delete_task_btn_wrapper} btn-box d-md-flex w-100`}
          >
            <button
              type="button"
              className={`${styles.delete_task_btn} button button-round button-shadow mr-md-4 mb-3 w-sm-100`}
              onClick={handleApply}
            >
              {t("officePolicyManagement.yesCancel")}
            </button>
            <button
              type="button"
              className={`${styles.delete_task_btn} mb-md-3 button button-round button-border btn-mobile-link button-dark`}
              onClick={toggle}
            >
              {t("officePolicyManagement.noCancel")}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
